import React, { Component } from "react";

import "./Footer.scss"
import "../../static/fonts/opensanshebrew/stylesheet.css";

class Footer extends Component {
  render() {
    return (
      <footer>
        <div id="footer">
          <div className="padding">
          <ul>
            <a href="http://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" target="_blank">תנאי שימוש</a>
            <li className="line"></li>
            <a href="http://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" target="_blank">מדיניות פרטיות</a>
            <li className="line"></li>
            <a href="//www.yit.co.il?utm_source=mynet.co.il&utm_medium=referral&utm_campaign=carousal" target="_blank">עיצוב, איפיון ופיתוח <li className="yitlogo"></li></a>
            
            </ul>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
